'use client';

import {
  HomeLandingSections,
  HomeStoriesSection,
  HomeCommunitySection,
  HomeVoicesSection,
  HomeAboutSection,
} from '@/components/homePageSections';

import { useState } from 'react';
import Header from '@/components/Header';
import HomeHeroSection from '@/components/HomeHeroSection';
import { BRAND_FACTS } from '@/config/brandFacts';

export default function TawdeVivah() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  return (
    <div className="bg-white">
      {/* Transparent Header */}
      <Header variant="transparent" />

      <HomeHeroSection
        title="कोकणस्थ मराठा वधू-वरांसाठी"
        subtitle="महाराष्ट्रातील अग्रणी विवाहसंस्था"
        trackingSource="tawde_vivah"
      />

      <HomeLandingSections />

      <HomeStoriesSection />

      <HomeCommunitySection />

      <HomeVoicesSection />

      <HomeAboutSection />

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
            Frequently Asked Questions
          </h2>
          <div className="max-w-4xl mx-auto">
            <div className="space-y-4">
              {[
                {
                  question: "How can Kokanastha Maratha Vadhu Var contact the office?",
                  answer: `Kokanastha Maratha community bride & grooms can call on ${BRAND_FACTS.phone} or email on contact@marathivadhuvarsuchak.com to enquire with Marathi Vadhu Var Suchak support team.`
                },
                {
                  question: "How to do Kokanastha Maratha Vadhu Var profile search online?",
                  answer: "It's simple! Just register your profile online through marathivadhuvarsuchak.com/register link and then after approval Kokanastha Maratha community bride and grooms can search profile online."
                },
                {
                  question: "How can Kokanastha Maratha Vadhu Var download App?",
                  answer: "Marathi Vadhu Var Suchak app will be launch soon, and then you can search Kokanastha Maratha community Vadhu Var profiles online."
                },
                {
                  question: "How to search Kokanastha Maratha Vadhu Var Sindhudurg profiles?",
                  answer: "Just register free through marathivadhuvarsuchak.com and after approval you can search profiles of Sindhudurg brides."
                }
              ].map((faq, index) => (
                <div key={index} className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === index ? null : index)}
                    className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-gray-50 transition-colors"
                  >
                    <h3 className="text-lg font-semibold text-gray-900">
                      {faq.question}
                    </h3>
                    <svg
                      className={`w-5 h-5 text-gray-500 transition-transform duration-300 ${
                        openFAQ === index ? 'rotate-180' : ''
                      }`}
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>
                  <div
                    className={`px-6 transition-all duration-300 ease-in-out ${
                      openFAQ === index ? 'pb-4 max-h-96 opacity-100' : 'max-h-0 opacity-0 overflow-hidden'
                    }`}
                  >
                    <div className="text-gray-600 leading-relaxed py-3">
                      <p className="mb-3">{faq.answer}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Tawde Vivah for Kokanastha Maratha Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-8">
            Who is Kokanastha Kshatriya Maratha Samaj?
            </h2>
            <p className="text-gray-700 leading-relaxed" style={{ fontSize: '1.11rem' }}>
            The Kokanastha Kshatriya Maratha Samaj is a proud and historically distinguished community with deep roots along the Konkan coastline of Maharashtra, known for their warrior heritage, strong moral values, and rich cultural traditions. Descended from the valiant Kshatriya lineage, this Samaj has played a significant role in shaping the social, political, and cultural fabric of Maharashtra across centuries. The community is known for its strong emphasis on education, family honor, Kul traditions, and adherence to Vedic customs - values that are beautifully reflected in their approach to marriage and social life. Kokanastha Maratha families take great pride in preserving their Gotra, Kul Devata traditions, and regional customs while embracing modern values of education and professional growth. Marriage within this Samaj is considered a sacred union that upholds the dignity and legacy of the Kokanastha Kshatriya identity for future generations. At MarathiVadhuVarSuchak.com, we proudly serve the Kokanastha Kshatriya Maratha Samaj with dedicated Vadhu Var profiles that respect both tradition and the aspirations of today's generation. Few popular surnames from Kokanastha Kshatriya Maratha Samaj are Tawde, Rane, Bagwe, Parab & many more.
            </p>
          </div>
        </div>
      </section>

    </div>
  );
}
